import { connect } from 'react-redux';
import { selectSortedQueuesByPriorityAndName } from '../../../../app/utils/reselect';
import Queue from '../../components/modals/queue';
const mapStateToProps = (state, ownProps) => {
    var _a, _b;
    const message = ((_b = (_a = ownProps.node) === null || _a === void 0 ? void 0 : _a.payload) === null || _b === void 0 ? void 0 : _b.welcome_message)
        ? ownProps.node.payload.welcome_message
        : '';
    return {
        queuesState: selectSortedQueuesByPriorityAndName(state),
        initialValues: Object.assign(Object.assign({}, ownProps.node), { message }),
    };
};
export default connect(mapStateToProps)(Queue);
